




















































































import Vue from 'vue';
import ResetButton from '@/components/common/control/CtrlResetBtn.vue';
import ClearButton from '@/components/common/control/CtrlClearBtn.vue';
import AddButton from '@/components/common/control/CtrlAddBtn.vue';
import ActionsBtn from '@/components/G_kaigai/G_KAIGAI_ActionsBtn.vue';
import CtrlMessageDialog from '@/components/common/control/CtrlMessageDialog.vue';
import G_150_HaisoMstMente_ChildHeaderInput from '@/components/G_kaigai/G_150_HaisoMstMente_ChildHeaderInput.vue';
// ★いったん削除
// //import G_150_HaisoMstMente_Table from '@/components/G_kaigai/G_150_HaisoMstMente_Table.vue';
import {ShoriKb,OutStatus} from '@/constants/constants';
import { mapGetters } from 'vuex';
import { getDefaultPagerInfo } from '@/utils/utils';
// いったん「any」で対応
//import { haisoMstType } from '@/types/G_kaigai/G_150_HaisoMstMente';

/* eslint-disable @typescript-eslint/no-explicit-any */
export default Vue.extend<any, any, any, any>({
  name: 'haisoMstMente',
  components: {
    ResetButton,
    ClearButton,
    AddButton,
    ActionsBtn,
    CtrlMessageDialog,
    G_150_HaisoMstMente_ChildHeaderInput,
// ★いったん削除
//    G_150_HaisoMstMente_Table,
  },
  data: () => ({
    isDialogOpen: false,
    isAdd: true,
    isNote: false,
    isEdit: false,
    /* 項目名はpackege内の記述と一致させる */
    headers: [
      { text: '配送会社コード', value: 'itakusakiCd', width: 160 },
      { text: '配送会社名１', value: 'itakusakiMei1', width: 360 },
      { text: '配送会社２', value: 'itakusakiMei2', width: 360 },
      { text: '配送会社略名', value: 'itakusakiRyakuMei', width: 360 },
      { text: '更新日', value: 'koshinDate', width: 200 },
      { text: '', value: 'action', width: 80, sortable: false },
    ],
    item: {},
    search: '',
    shoriKb: ShoriKb.ADD,
    footerProps: {},
    /* ★どうしてこの記述で100が初期値になるのかわからない*/
    options: {
      page: 1,
      itemsPerPage: 10,
      sortBy: [],
      sortDesc: [],
    },
    wMessage: false,
    wMessageId: '',
    wMessageTextParam: [] as string[],
    isReloadStopFlg: false,
  }),
  /* この記載によりリストが更新されると自動で画面に反映する */
  computed: {
    ...mapGetters({
      userInfo: 'common/userInfo',
      list: 'g150/haisoList',
    }),
    tableHeight() {
      return this.$vuetify.breakpoint.height - 290;
    },
  },
  methods: {
    async onReset() {
      const response = await this.$store.dispatch('g150/getHaisoList', {});
      if (
        response &&
        response.status == 200 &&
        response.data &&
        response.data.error &&
        response.data.error.outStatus &&
        response.data.error.outStatus != OutStatus.NORMAL
      ) {
        this.wMessageId = response.data.error.messageID;
        this.wMessageTextParam = response.data.error.messageArgs;
        this.wMessage = true;

        // [OutStatus.CHECK_ERR] は、自画面の再検索を行わない
        if (response.data.error.outStatus == OutStatus.CHECK_ERR) {
          this.isReloadStopFlg = true;
        }
        return;
      }
    },
    async onLoad() {
      this.$store.dispatch('g150/resetHaisoList');
      this.onReset();
    },
    onClear() {
      this.search = '';
      this.$store.dispatch('g150/resetHaisoList');
    },
    //追加ボタン
    async onAdd() {
      await this.$store.dispatch('g150/resetHaisoMst');

      // 引数
      //    処理区分:ADD[0]
      //    品目大分類コード:なし
      //    更新回数:なし
      this.item = {};
      this.isDialogOpen = !this.isDialogOpen;
      this.shoriKb = ShoriKb.ADD;

      // ヘッダ入画面を閉じた後の reset 処理は、ヘッダ入力画面側から制御するので、ここには実装しない
    },
    // 参照ボタン
    // 型の指定なので「any」記述でもＯＫ
    //async onInfo(item: haisoMstType) {
    onInfo(item: any) {
      this.item = item;
      this.isDialogOpen = !this.isDialogOpen;
      this.shoriKb = ShoriKb.REFER;
    },

    // ヘッダ入力画面を閉じて、reset icon click を実行する
    handleClose(reload: boolean) {
      this.isDialogOpen = false;
      this.item = {};
      reload && this.onReset();
    },

    //編集アイコン
    onEdit(item: any) {
      // 引数
      //    処理区分:UPD[2]
      //    配送会社ード:選択行の [配送会社コード]
      //    更新回数:選択行の [更新回数]
      this.item = item;
      this.isDialogOpen = !this.isDialogOpen;
      this.shoriKb = item.mukoFlg ? ShoriKb.DEL_CANCEL : ShoriKb.UPD;

      // ADD: 0, // 追加
      // REFER: 1, // 参照
      // UPD: 2, // 編集
      // CANCEL: 3, // 取消
      // COPY: 4, // 複写
      // TEISEI: 5, // 訂正
      // IKKATSU: 6, // 一括計上
      // DEL_CANCEL: 7, // 削除取消
      // TEISEI_CANCEL: 8, // 訂正取消

      // ヘッダ入画面を閉じた後の reset 処理は、ヘッダ入力画面側から制御するので、ここには実装しない
    },

    // response error の場合の message dialog で OK click
    handleWarnExit() {
      this.wMessage = false;
      this.wMessageId = '';
      this.wMessageTextParam = [];

      // KI_W121 の場合は、clear しない
      if (!this.isReloadStopFlg)
        this.$store.dispatch('g150/resetHaisoList');
      
      this.isReloadStopFlg = false;
    },
  },
  async created() {
    // v-data-table の footer制御
    const pagerInfo = getDefaultPagerInfo();
    this.footerProps = pagerInfo.footerProps;
    this.options.itemsPerPage = pagerInfo.itemPerPage;

    // reset icon click 初期表示やめる
    //this.$store.dispatch('g150/resetHaisoList');
    //this.onReset();
  },
});
